import { css } from '@emotion/css';

import {
  Breakpoints,
  Colors,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const contentHeaderClassName = css({
  alignItems: 'center',
  display: 'flex',
  minHeight: 42,
});

export const bottomSpacingClassName = css({
  marginBottom: Spacing['2XS'],
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: 22,
  fontWeight: FontWeight.BOLD,
});

export const badgeClassName = css({
  marginLeft: Spacing.SM,
});

export const rightHeaderClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginLeft: 'auto',
});

export const contentBodyClassName = css({
  paddingTop: Spacing.XL,
  [SMALL_DEVICE_MQ]: {
    paddingTop: Spacing.LG,
  },
});

export const contentCardClassName = css({
  background: Colors.White,
  borderTop: `1px solid ${Colors.LightGray}`,
  marginTop: Spacing.XL,
  overflow: 'hidden',
  paddingTop: Spacing.XL,
  '&:first-child': {
    borderTop: 'none',
    marginTop: 0,
    paddingTop: 0,
  },
  [SMALL_DEVICE_MQ]: {
    borderTop: 'none',
    border: '1px solid transparent',
    boxShadow:
      '0px 2px 4px 0px rgb(63, 63, 63, 0.1), 0px -1px 2px rgb(63, 63, 63, 0.075)',
    borderRadius: 12,
    paddingTop: 0,
  },
});

export const innerClassName = css({
  padding: 0,
  position: 'relative',
  [SMALL_DEVICE_MQ]: {
    padding: Spacing.LG,
  },
});

export const noPaddingClassName = css({
  padding: 0,
  [SMALL_DEVICE_MQ]: {
    padding: 0,
  },
});

export const noBorderClassName = css({
  border: 'none',
});

export const noSpacingClassName = css({
  margin: 0,
  [`@media (max-width: ${Breakpoints.SM}px)`]: {
    borderTop: 0,
    paddingTop: 0,
  },
});
